module.exports = __webpack_public_path__ + "img/felicitacion.48c24ac3.png";